import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconCalendarStyle0 = stylesCss;

const BiIconCalendar$1 = /*@__PURE__*/ proxyCustomElement(class BiIconCalendar extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '0f77385ade9a3d83bbd2c64b2e80cee5669208e8', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: 'bc1a07fa6bb9b5222725271c91ec0da96e9d0640', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: 'ea4dad7371b0cc2a2d1f21ac673b67a4b131a74a', "fill-rule": 'evenodd', d: 'M8.359 5.073V3.576h1.5v1.497h5.984V3.576h1.5v1.497h4.509v13.232a3.247 3.247 0 0 1-3.247 3.246H7.122a3.247 3.247 0 0 1-3.247-3.246V5.073H8.36Zm0 1.5H5.375v3.243h14.977V6.573h-3.009V8.07h-1.5V6.573H9.859V8.07h-1.5zm11.993 4.743H5.375v6.989c0 .963.783 1.746 1.747 1.746h11.483c.964 0 1.747-.782 1.747-1.746zm-13.48 1.496H9.12v2.248H6.871v-2.248Zm3.494 0h2.249v2.248h-2.249zm3.495 0h2.249v2.248h-2.25v-2.248Zm-6.99 3.495H9.12v2.248H6.871zm3.495 0h2.249v2.248h-2.249z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconCalendarStyle0; }
}, [1, "bi-icon-calendar", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-calendar"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-calendar":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconCalendar$1);
            }
            break;
    } });
}

const BiIconCalendar = BiIconCalendar$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconCalendar, defineCustomElement };
